import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss']
})
export class DefaultHeaderComponent implements OnInit{

  userName:string = '';
  role:string = '';

  constructor(public common:CommonFunctionService, private authService:AuthService){}
  ngOnInit(): void {
    
 this.userName = this.common.userName;
 this.role = this.common.role;
  }

  toggle() {
    document.body.classList.toggle('sidebar-lg-show');
    window.dispatchEvent(new Event('resize'));
  }

  logout(){
    this.authService.logout();
  }
}
